<template>
  <div class="card indexer-logs sticky-top">
    <h5 class="card-header bg-secondary-subtle">
      {{ $t('words.tasksHistory') }}
    </h5>
    <div class="card-body">
      <ul class="list-group list-group-flush">
        <li
          v-for="log in currentIndexerLogs"
          :key="log.id"
          class="list-group-item"
          @click="$router.push({
            name: 'TaskDetail',
            params: { id: log.id }
          })"
        >
          <div class="log-date text-muted">
            {{ log.stop_date ?
              new Date(log.stop_date).toLocaleString() : log.creation_date ?
                new Date(log.creation_date).toLocaleString() : '' 
            }}
          </div>
          <div>
            <span
              :class="`text-bg-${getColorClass(log.state)}`"
              class="badge"
            >
              {{ log.state_label }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'IndexerLogs',

  data() {
    return {
      colors: {
        SUCCESS: '55ffaa',
        FAILURE: 'ff5555',
        WARNING: 'fff033'
      }
    };
  },

  computed: {
    ...mapState('indexers', [
      'currentIndexerLogs',
    ]),
  },

  methods: {
    getColorClass(state) {
      switch (state) {
      case 'APPENDED':
        return 'primary';
      case 'FAILURE':
        return 'danger';
      case 'SUCCESS':
        return 'success';
      default:
        return 'secondary';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.indexer-logs {
  margin-top: 1.8rem;
  top: 4.5rem;
  .card-header {
    font-weight: bold;
  }
  .card-body {
    padding: 0.75rem 1.25rem;
  }
  .list-group-item {
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .log-date {
      font-size: 0.8rem;
      font-weight: bold;
    }
  }
  .list-group-item:hover {
    background-color: aliceblue;
  }
}
</style>